import { render, staticRenderFns } from "./LastSurvior.vue?vue&type=template&id=3c71a592&"
import script from "./LastSurvior.vue?vue&type=script&lang=js&"
export * from "./LastSurvior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports